const APP_ENV = process.env.REACT_APP_ENV;

let envConfig;

const dev = {
  auth_url: `https://cb-auth.dev.loop.co.za`,
  base_url: `https://master-api.dev.loop.co.za`,
  upload_url: `https://cb-image-upload-api-ukxjb66ceq-ew.a.run.app`
};

const prod = {
  auth_url: `https://cb-auth.loop.co.za`,
  base_url: `https://master-api.loop.co.za`,
  upload_url: `https://cb-image-upload-api-f5dovyimaq-ew.a.run.app`
};

const app_images = {
  default_logo: `http://cowabunga.co.za/static/img/logo.svg`
};

switch (APP_ENV) {
  case 'production':
    envConfig = prod;
    break;
  case 'development':
    envConfig = dev;
    break;
  default:
    envConfig = dev;
    console.log(`environment does not exist, check yaml files.`);
}

export const config = {
  uri: envConfig,
  images: app_images
};
